import { AuthConfig } from 'angular-oauth2-oidc';

let redirectUri: string;
if (document.location.hash || /\.html\b/.test(document.baseURI)) {
  let path = document.location.pathname;
  if (path.endsWith('/')) {
    path += 'auth-redirect.html';
  } else if (path.includes('/')) {
    // remove everything after last slash
    path = path.substring(0, path.lastIndexOf('/')) + '/auth-redirect.html';
  } else {
    path = '/auth-redirect.html';
  }
  redirectUri = document.location.origin + path;
} else {
  redirectUri = document.baseURI + 'auth-redirect.html';
}

export const loadAuthConfig = (ftfBaseUrl: string, clientId: string): AuthConfig => ({
  issuer: 'ftf',
  skipIssuerCheck: true,
  redirectUri,
  loginUrl: `${ftfBaseUrl}oauth/authorize`,
  tokenEndpoint: `${ftfBaseUrl}oauth/token`,
  clientId,
  responseType: 'code',
  scope: 'openid offline_access full',
  showDebugInformation: true,
  oidc: true,
  disablePKCE: false,
});
